﻿document.addEventListener('DOMContentLoaded', () => {
    const $selectNav = document.getElementById('selectNav');
    if ($selectNav !== null && typeof $selectNav !== 'undefined') {
        $selectNav.addEventListener('change', (event) => {
            if (event.target.value !== '') {
                window.location.href = event.target.value;
            }
        });
    }
});